import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { deleteNote } from '../../actions/favoriteEntities/notes';
import { DeleteButton } from '../../components/DeleteButton';
import { selectResults } from '../../selectors';
import { trackCommentEdit } from '../EditCommentButtonContainer/trackings';

interface IDeleteCommentButtonContainerProps {
  entityId: number;
}

export const DeleteCommentButtonContainer = ({ entityId }: IDeleteCommentButtonContainerProps) => {
  const dispatch = useDispatch();

  const { deletingNotes } = useSelector(selectResults);

  const showPreloader = Boolean(deletingNotes.find(id => id === entityId)) || false;

  const handleDeleteCommentClick = React.useCallback(() => {
    const params = { entityId, comment: '' };

    dispatch(deleteNote(params));

    trackCommentEdit();
  }, [dispatch, entityId]);

  return <DeleteButton showPreloader={showPreloader} onDeleteCommentClick={handleDeleteCommentClick} />;
};
